import React from 'react';

const Shortlisting = () => {
  return (
    <div>Shortlisting</div>
  );
};

export default Shortlisting;